<template>
  <button
    type="button"
    class="absolute -left-3 -top-3 z-10 -translate-x-1/2 -translate-y-1/2 inline-flex items-center justify-center rounded-xl border border-primary-200 bg-white p-1 text-primary-600 shadow hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-primary-300"
    @click="$emit('toggle')"
  >
    <img :src="iconSrc" alt="" class="h-4 w-4"/>
  </button>
</template>

<script>
import foldIcon from '@/assets/icons/fold-vertical.svg'
import unfoldIcon from '@/assets/icons/unfold-vertical.svg'

export default {
  name: 'DashboardRowToggle',
  props: {
    collapsed: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    iconSrc () {
      return this.collapsed ? unfoldIcon : foldIcon
    }
  }
}
</script>
